"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemByIdExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const utils_1 = require("../../../utils");
const services_1 = tslib_1.__importDefault(require("../../../services"));
const getIncludesParams_1 = require("../../../shared/getIncludesParams");
const getItemById = toolkitRaw.createAsyncThunk('bookings/fetch_item_by_id', async (id, { rejectWithValue }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    try {
        const response = await services_1.default.get(`/api/saas/me/items/${id}`, {
            params: {
                includes: (0, getIncludesParams_1.getDefaultIncludesParams)('saas_items'),
            },
        });
        const payload = (0, utils_1.deserialize)(response.data);
        const responseData = payload.data;
        const data = {
            ...responseData,
            meta: {
                ...payload.data.meta,
                category_id: Number(((_e = (_d = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.relationships) === null || _c === void 0 ? void 0 : _c.category) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.id) || 0),
                owner_address: Number(((_k = (_j = (_h = (_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.relationships) === null || _h === void 0 ? void 0 : _h.owner_address) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.id) || 0),
            },
        };
        // organize pricing rules by minutes
        if (data.pricing_rules) {
            data.pricing_rules = data.pricing_rules.sort((a, b) => {
                return a.minutes - b.minutes;
            });
        }
        return data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getItemByIdExtraReducers = (builder) => {
    builder.addCase(getItemById.pending, (state) => {
        state.item.loading = true;
    });
    builder.addCase(getItemById.fulfilled, (state, action) => {
        state.item.loading = false;
        state.item.data = action.payload;
    });
    builder.addCase(getItemById.rejected, (state) => {
        state.item.loading = false;
    });
};
exports.getItemByIdExtraReducers = getItemByIdExtraReducers;
exports.default = getItemById;
//# sourceMappingURL=index.js.map